import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../createApiConfig';

export const cMLanguagesApi = createApi({
  reducerPath: 'cMLanguagesApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['Languages'],
  endpoints: (builder) => ({
    listCampaignsLanguages: builder.query({
      query: (params) => ({
        url: `/campaigns/languages/`,
        params,
      }),
      providesTags: ['Languages'],
      
    }),

    createCampaignsLanguages: builder.mutation({
      query: (data) => ({
        url: `/campaigns/languages/`,
        method: 'POST',
        body: data,
      }),
      providesTags: ['Languages'],
    }),

    updateCampaignsLanguages: builder.mutation({
      query: ({ id, data }) => ({
        url: `/campaigns/languages/${id}/`,
        method: 'PATCH',
        body: data,
      }),
      providesTags: ['Languages'],
    }),

    deleteCampaignsLanguages: builder.mutation({
      query: (id) => ({
        url: `/campaigns/languages/${id}/`,
        method: 'DELETE',
      }),
      providesTags: ['Languages'],
    }),
  }),
});

export const {
  useListCampaignsLanguagesQuery,
  useCreateCampaignsLanguagesMutation,
  useUpdateCampaignsLanguagesMutation,
  useDeleteCampaignsLanguagesMutation,
} = cMLanguagesApi;
